import { ReactNode } from "react";
import { useNotificationPropertiesByCode } from "../use-notification-properties-by-code";
import { InnerPropertiesProvider } from "./inner-properties-provider";

export function ProvidePropertiesByTemplateCode({
  code,
  children,
}: {
  code: string;
  children: ReactNode;
}) {
  const { data } = useNotificationPropertiesByCode(code);

  return (
    <InnerPropertiesProvider
      properties={data?.getNotificationPropertiesByCode ?? []}
    >
      {children}
    </InnerPropertiesProvider>
  );
}
